// window.onload = function() {
//     getAllIdVideo();
// }

window.onload = function() {
    setTimeout(function(){
      getAllIdVideo();
 }, 3000);
   
}

var getAllIdVideo = () => {
    let allVideos = document.getElementsByClassName('video-block__content__wrapper');
    let arrayId = [];
    for (let i = 0; i < allVideos.length; i++) {
        arrayId.push(allVideos[i].getAttribute('data-id-video'))
    }
    requestData(arrayId.join('&id='))
}

var requestData = (list_id_videos) => {
    // let apiKey = "AIzaSyDNNHnLCFiHWNG6cpugjHQGm461qZveXRM";
  let apiKey = "AIzaSyDXuGUmu-3rOGr1bcRuXRUdHM5KbYWeCk8";
    fetch(`https://www.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&id=${ list_id_videos }&key=${ apiKey }`)
    .then(res => res.json())
    .then(data => {
      renderVideoContent(data.items)
    })
    .catch(rejected => {
        console.log(rejected);
    });
}

var kFormatterViews = (num) => {
    let newDate;
    if (Math.abs(num) <= 999) {
        newDate = `${Math.sign(num)*Math.abs(num)} views`
    } else if (Math.abs(num) > 999 && Math.abs(num) < 1000000 ) {
        newDate = `${Math.sign(num)*((Math.abs(num)/1000).toFixed(1))}K views`
    } else if (Math.abs(num) >= 1000000) {
        newDate = `${Math.sign(num)*((Math.abs(num)/1000000).toFixed(1))}M views`
    } return newDate;
}

var timeAgoFormatDate = (date) => {
    let ourDate = Math.floor((( new Date() - new Date(date)) / (1000 * 60 * 60 * 24)));//how many days from publish
    let newDate;
    let daysYear = 365;
    let daysMonth = 30;
    
    if (ourDate <= daysMonth) {
        newDate = `${ourDate} days ago`
    } else if ((ourDate/daysMonth) < 2){
        newDate = `1 month ago`
    } else if (((ourDate/daysMonth) >= 2) && ourDate < daysYear) {
        newDate = `${Math.floor( ourDate/daysMonth )} months ago`
    } else if (ourDate >= daysYear && ourDate <= 730){
        newDate = `${Math.floor(ourDate/daysYear)} year ago`
    } else if (ourDate > 730){
        newDate = `${Math.floor(ourDate/daysYear)} years ago`
    } 
    return newDate;
}
function ytDurationToSeconds(duration) {
    var match = duration.match(/PT(\d+H)?(\d+M)?(\d+S)?/);
  
    match = match.slice(1).map(function(x) {
      if (x != null) {
          return x.replace(/\D/, '');
      }
    });
  
    var hours = (parseInt(match[0]) || 0);
    var minutes = (parseInt(match[1]) || 0);
    var seconds = (parseInt(match[2]) || 0);
    
    var newFormat = (el) => {
        var element = String(el)
        var newEl;
        if (element.length == 1) {
            newEl = "0" + el
        } else { 
            newEl = el 
        } return newEl;
    } 
    return `${newFormat(hours)}:${newFormat(minutes)}:${newFormat(seconds)}`
}

var renderVideoContent = (arrData) => {
  for (let i = 0; i < arrData.length; i++) {
    let videoDuration = document.getElementById(`duration__${arrData[i].id}`);
    let videoTitle = document.getElementById(`title__${arrData[i].id}`);
    let videoViews = document.getElementById(`views__${arrData[i].id}`);
    let videoDate = document.getElementById(`date__${arrData[i].id}`);
    let videoDescription = document.getElementById(`description__${arrData[i].id}`);

    videoDuration.innerHTML = ytDurationToSeconds(arrData[i].contentDetails.duration);
    videoTitle.innerHTML = arrData[i].snippet.localized.title;
    videoViews.innerHTML = kFormatterViews(arrData[i].statistics.viewCount);
    videoDate.innerHTML = timeAgoFormatDate(arrData[i].snippet.publishedAt);
    videoDescription.innerHTML = `${arrData[i].snippet.localized.description.slice(0, 90)} ... `;

    videoDescription.classList.remove('load-effect');
    videoTitle.classList.remove('load-effect');
    videoViews.classList.remove('load-effect');
    videoDate.classList.remove('load-effect'); 
  }
}